// import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const convertToDateFormat = (isoDate) => {
  const formattedDate = new Date(isoDate).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return formattedDate;
};

export const getTimeWithTimeZone = (
  utcDateTimeString,
  timeZone,
  format = 'h:mm a'
) => {
  const dateObj = new Date(utcDateTimeString);
  const formattedDate = formatInTimeZone(dateObj, timeZone, format);
  return formattedDate;
};

export const getDateWithTimeZone = (
  utcDateTimeString,
  timeZone,
  format = 'MMM d, yyyy'
) => {
  const dateObj = new Date(utcDateTimeString);
  const formattedDate = formatInTimeZone(dateObj, timeZone, format);
  return formattedDate;
};

export const calculateAge = (birthDate) => {
  const today = new Date();
  const birthDateObj = new Date(birthDate);
  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }

  return age;
};
